// 验证码相关

import request from '@/utils/request'

/* 发送验证码
@params
data 
{
    "phone": "**********"
}
@return 
{"code": "0",
    "method": "sms.send",
    "message": "手机验证码已发送，请收到短信后输入，20分钟有效"
}
*/
export function send(data) {
    return request({
        method: 'post',
        url: "/",
        data: {
            method: "sms.send",
            data: data
        }
    })
}

/* 验证验证码
@params
data 
{   
    "code" :"****"
    "phone": "**********"
}
@return 
{
    "code": "0",
    "method": "sms.check"
    "message": "SUCCESS"
}
*/
export function check(data) {
    return request({
        method: 'post',
        data: {
            method: "sms.check",
            data: data
        }
    })
}


// WEBPACK FOOTER //
// ./src/api/code.js